import Vue from 'vue';
import VueI18n, {LocaleMessages} from 'vue-i18n';
import axios from 'axios';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en'
})

const loadedLanguages: string[] = [];

function setI18nLanguage(lang: string) {
    i18n.locale = lang;
    return lang;
}

export function loadLanguageAsync(lang: string) {
    if (loadedLanguages.includes(lang)) {
        if (i18n.locale !== lang) {
            setI18nLanguage(lang)
        }
        return Promise.resolve()
    }
    return axios.get(process.env.VUE_APP_API_URL + `/i18n/${lang}`).then(response => {
        const msgs = response.data;
        loadedLanguages.push(lang)
        i18n.setLocaleMessage(lang, msgs.data);
        setI18nLanguage(lang)
    }).catch(error => {
        loadedLanguages.push(lang);
    });
}

export default i18n;